import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Textarea } from "@/components/ui/textarea";
import { SignaturePad } from "@/components/SignaturePad";
import { Section, YesNo } from "@/components/wizard/controls";

export const StepPrechecks = ({ f, set }) => (
  <div className="space-y-5" data-testid="step-prechecks">
    <Section title="1. Verify rider identity" hint="Check the rider's driving licence (or passport).">
      <YesNo value={f.id_verified} onChange={(v) => set("id_verified", v)} yes="Identity verified" no="Not verified" testId="precheck-id" />
      <Input placeholder="Document checked, e.g. Driving licence" className="h-12" value={f.id_type} onChange={(e) => set("id_type", e.target.value)} data-testid="precheck-id-type-input" />
    </Section>
    <Section title="2. DVSA eyesight check" hint="Read a number plate from 20 metres in good daylight, using any prescribed glasses or contact lenses. Failure cancels the assessment.">
      <YesNo value={f.eyesight_pass} onChange={(v) => set("eyesight_pass", v)} yes="Passed" no="Failed" testId="precheck-eyesight" />
    </Section>
    {f.eyesight_pass && (
      <>
        <Section title="3. Rider Disclaimer & Indemnity" hint="The rider must complete the SSCBB Rider Disclaimer before the observed ride begins.">
          <label className="flex items-start gap-3 rounded-xl border p-4 text-sm">
            <Checkbox checked={f.disclaimer_signed} onCheckedChange={(v) => set("disclaimer_signed", !!v)} className="mt-0.5 h-5 w-5" data-testid="precheck-disclaimer-checkbox" />
            <span>I, the rider, confirm I have read and accept the SSCBB Rider Disclaimer and Indemnity Form, and that I hold valid insurance, licence and a roadworthy motorcycle for this observed ride.</span>
          </label>
          <div className="space-y-1.5">
            <Label>Rider full name (printed)</Label>
            <Input className="h-12" value={f.rider_signed_name} onChange={(e) => set("rider_signed_name", e.target.value)} data-testid="precheck-signed-name-input" />
          </div>
          <SignaturePad value={f.signature} onChange={(v) => set("signature", v)} />
        </Section>
        <Section title="4. Rider equipment" hint="Helmet, protective clothing, gloves and boots are appropriate.">
          <YesNo value={f.equipment_ok} onChange={(v) => set("equipment_ok", v)} yes="Appropriate" no="Not appropriate" testId="precheck-equipment" />
          <Textarea rows={2} placeholder="Equipment notes (optional)" value={f.equipment_notes} onChange={(e) => set("equipment_notes", e.target.value)} data-testid="precheck-equipment-notes" />
        </Section>
        <Section title="5. Recording permission" hint="Recording via any media is only allowed with the rider's express written permission and must not be shared.">
          <YesNo value={f.recording_permission} onChange={(v) => set("recording_permission", v)} yes="Permission given" no="No recording" testId="precheck-recording" danger="none" />
        </Section>
      </>
    )}
  </div>
);
